module.exports = __webpack_public_path__ + "img/2.9d9fd78d.png";